export default class Validators {
    static isEmail(email) {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    }
    static isBirthNumber(value) {
        const digits = value.replace('/', '');
        if (!/^\d{9,10}$/.test(digits))
            return false;
        if (digits.length === 9)
            return true;
        return Number(digits) % 11 === 0;
    }
    static isIco(value) {
        if (!/^\d{8}$/.test(value))
            return false;
        let sum = 0;
        for (let i = 0; i < 7; i++)
            sum += Number(value[i]) * (8 - i);
        return (11 - (sum % 11)) % 10 === Number(value[7]);
    }
}
